// extracted by mini-css-extract-plugin
export default {"buttonContainer":"oil-painting-example_buttonContainer__T3tvs","canvas":"oil-painting-example_canvas__iC+P9"};